<template>
  <div class="ess-element-wrap">
    <div class="ess-line" :class="get_line_class(data.data.state_eblock)"></div>
    <div class="ess-element">
      <div class="ess-element__header">
        <img src="@/assets/images/topo/ic_eblock.png" height="24">
        <span class="ess-element__name" :title="data.uuid">{{ data.eBlockName }}</span>

        <!-- <el-dropdown @command="handleCommand" placement="top">
          <el-icon class="ess-more">
            <More />
          </el-icon>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">详情</el-dropdown-item>
            <el-dropdown-item command="b">设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div class="ess-element__body">
        <div class="ess-element__info">
          <div class="ess-element__text" :title="$str.getKey('站级监控/eBlock工作状态')">{{ $str.getKey('数据可视化/状态') }}： <b
              class="ess-element__state" :class="get_s_class(data.data.state_eblock)">{{
                formatter_s(data.data.state_eblock)
              }}</b> </div>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/PCS直流侧功率')"> {{ $str.getKey('数据可视化/功率') }}： <b>{{
            formatter(data.data.p_dc) }}</b>kW</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/PCS直流侧电压')">{{ $str.getKey('数据可视化/电压') }}： <b>{{
            formatter(data.data.u_dc) }}</b>V</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/PCS直流侧电流')">{{ $str.getKey('数据可视化/电流') }}： <b>{{
            formatter(data.data.i_dc) }}</b>A</span>
        </div>
        <div class="ess-element__info">
          <span class="ess-element__text" :title="$str.getKey('站级监控/电池荷电量百分比')">SOC：<b>{{ formatter(data.data.soc) }}</b>%</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
import { More } from '@element-plus/icons-vue'
const $str = window.$str
const EBStatus = {
  1: $str.getKey('站级监控/停机'),
  2: $str.getKey('站级监控/待机'),
  3: $str.getKey('站级监控/充电'),
  4: $str.getKey('站级监控/放电'),
  5: $str.getKey('站级监控/降额'),
  6: $str.getKey('站级监控/告警'),
  7: $str.getKey('站级监控/故障'),
}

export default {
  setup() {
    return {
      $str
    }
  },
  props: ['data'],
  mixins: [mixin],
  components: {
    More
  },
  methods: {
    handleCommand(command) {
      showTopTip('click on item ' + command, 'success');
    },
    formatter(value) {
      if (value == null) {
        return '--'
      }
      return value
    },
    formatter_s(s) {
      return EBStatus[s] || '--'
    },
    get_s_class(s) {
      // charge
      if (s == 3) {
        return 'charge'
      }
      // discharge
      else if (s == 4) {
        return 'discharge'
      }
    },
    get_line_class(s) {
      // charge
      if (s == 3) {
        return 'down'
      }
      // discharge
      else if (s == 4) {
        return 'up'
      }
    },
    // get_battery_style(soc) {
    //   let color = '#52AF57'
    //   if (soc <= 10) {
    //     color = 'red'
    //   }
    //   else if (soc > 10 && soc <= 20) {
    //     color = 'orange'
    //   }
    //   return {
    //     width: soc + '%',
    //     background: color
    //   }
    // }
  }
}

</script>
